import script from "./MobileBottomBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileBottomBar.vue?vue&type=script&setup=true&lang=ts"

import "./MobileBottomBar.vue?vue&type=style&index=0&id=7761a56c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7761a56c"]])

export default __exports__